import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { authService } from "../../services/auth.service";
import Button from "../Button/Button";
import Input from "../input/Input";
import { yupResolver } from "@hookform/resolvers/yup";
import { createValidationSchemas } from "../../schemas/user.schema";
import Cookies from "js-cookie";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { profileUpdate } from "../../redux/slices/userSlice";
import { HttpService } from "../../services/base.service";
import GoogleLoginButton from "../googlebutton/googleLogin";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { timeZoneCityToCountry } from "../../services/countries";
import PinField from "react-pin-field";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import useSocialLogin from "../../hooks/useSocialLogin";
import { generateSecureToken } from "../../utils/navigateEditor";

const LoginModal = ({ setstate1, setPopup }) => {
  const [state, setstate] = useState(true);
  const [loading, setLoading] = useState(false);
  const [verifyOTP, setVerifyOTP] = useState(false);
  const [pin, setPin] = useState("");
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  // const { executeRecaptcha } = useGoogleReCaptcha();
  const [countdown, setCountdown] = useState(60);
  const [isResending, setIsResending] = useState(false);
  const { t, i18n } = useTranslation();
  const validationSchemas = createValidationSchemas(t);

  useEffect(() => {
    let interval;
    if (isResending) {
      interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isResending]);
  useEffect(() => {
    if (countdown === 0) setIsResending(false);
  }, [countdown]);
  const resendCodeHandler = async () => {
    authService
      .resendOTP({
        email: email,
      })
      .then(() => {
        toast.success(t("OTP resent to registered email"));
      })
      .catch((error) => {});
    setCountdown(60);
    setIsResending(true);
  };
  const handleLoginSuccess = () => {
    setLoading(false);
    setstate1(-1);
    setPopup(false);
  };

  const { handleGoogleLogin } = useSocialLogin(handleLoginSuccess, setstate1);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchemas.validateLoginForm,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        // if (!executeRecaptcha) {
        //   toast.error(t("Error occur while submitting form"));
        //   setLoading(false);
        //   return;
        // }

        const token = generateSecureToken();

        if (!token) {
          toast.error(t("Error occur while submitting form"));
          setLoading(false);
          return;
        }

        const user = await authService.login({
          token: token,
          email: values.email.toLowerCase(),
          platform: "web",
          password: values.password,
          device_id: Cookies.get("device_id"),
        });

        if (user.status === 200) {
          if (user.data.data?.require2FA === true) {
            setEmail(values.email.toLowerCase());
            setLoading(false);
            setVerifyOTP(true);
            toast.error(t("Please enter OTP code"));
          } else {
            Cookies.set("session_id", user?.data?.data?.access_token, {
              domain: process.env.REACT_APP_PUBLIC_DOMAIN,
              path: "/",
            });
            Cookies.set("device_id", user?.data?.data?.device_id, {
              domain: process.env.REACT_APP_PUBLIC_DOMAIN,
              path: "/",
            });
            HttpService.setToken(user?.data?.data?.access_token);
            const obj = {
              status: user.data.status,
              success: user.data.success,
              message: user.data.message,
              data: user.data.data.profile,
            };
            dispatch(profileUpdate(obj));
            setLoading(false);
            setstate1(-1);
            setPopup(false);
          }
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          console.log(error.response);
        }
      }
    },
  });

  const getCountry = async () => {
    try {
      var userRegion;
      var userCity;
      var userCountry;
      var userTimeZone;

      if (Intl) {
        userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var tzArr = userTimeZone.split("/");
        userRegion = tzArr[0];
        userCity = tzArr[tzArr.length - 1];
        userCountry = timeZoneCityToCountry[userCity];
      }

      return userCountry;
    } catch (error) {
      return "";
    }
  };

  const googleAuthenticationHandler = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        setLoading(true);
        const country = await getCountry();

        const user = await authService.socialLogin({
          access_token: response.access_token,
          country: country,
          platform: "web",
          provider: "google",
          device_id: Cookies.get("device_id"),
        });

        if (user.status === 200) {
          handleLoginSuccess();
        }
      } catch (error) {
        toast.error(t("Login Failed"));
        console.log("Login Failed", error);
      }
    },
    onError: (error) => {
      toast.error(t("Login Failed"));
      console.log("Login Failed", error);
    },
  });

  const handleVerifyOTP = async (pin) => {
    try {
      setLoading(true);

      // if (!executeRecaptcha) {
      //   toast.error(t("Error occur while submitting form"));
      //   setLoading(false);
      // }

      //@ts-ignore
      const token = generateSecureToken();

      if (!token) {
        toast.error(t("Error occur while submitting form"));
        setLoading(false);
      }

      const user = await authService.twoFALogin({
        token: token,
        email: email,
        otp: pin,
        device_id: Cookies.get("device_id"),
      });
      if (user.status === 200 || user.status === 201) {
        Cookies.set("session_id", user?.data?.data?.access_token, {
          domain: process.env.REACT_APP_PUBLIC_DOMAIN,
          path: "/",
        });
        Cookies.set("device_id", user?.data?.data?.device_id, {
          domain: process.env.REACT_APP_PUBLIC_DOMAIN,
          path: "/",
        });
        HttpService.setToken(user?.data?.data?.access_token);
        console.log(user.data);
        const obj = {
          status: user.data.status,
          success: user.data.success,
          message: user.data.message,
          data: user.data.data.profile,
        };
        dispatch(profileUpdate(obj));
        setLoading(false);
        setstate1(-1);
        setPopup(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        console.log(error.response);
      }
    }
  };

  return (
    <div className="w-full">
      {verifyOTP ? (
        <div className="flex flex-col gap-10">
          <a
            href={`${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}`}
            className="cursor-pointer xl:w-36 w-30 h-12 relative flex-shrink-0 mx-auto"
          >
            <img
              src="https://gopdf.s3.eu-central-1.amazonaws.com/logos/Logo+go+pdf.svg"
              alt="Go PDF"
              fill={true}
              className="w-full h-full object-contain"
            />
          </a>
          <div>
            <h3 className="modal-heading mb-1">
              {t("Email Verification")}
            </h3>
            <p className="modal-description !text-base">
              {t(
                "Please enter the 4 digit code we have sent you. Did not received the code?"
              )}{" "}
              {!isResending && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  href="#"
                  className="text-primary font-normal text-base"
                  onClick={() => resendCodeHandler()}
                >
                  Resend
                </a>
              )}
              {isResending && (
                <span>
                  {t("Resend in")} {countdown} {t("seconds")}
                </span>
              )}
            </p>
          </div>

          <div className="flex flex-col gap-10">
            <div className="grid grid-cols-4 flex-wrap mb-8 border border-secondary-30 rounded-lg divide-x divide-secondary-30">
              <PinField
                type="number"
                length={4}
                validate={/^[0-9]$/}
                onChange={async (pin) => {
                  setPin(pin);
                  if (pin && pin.length === 4) {
                    handleVerifyOTP(pin);
                  }
                }}
                className="bg-transparent appearance-none overflow-y-auto text-secondary py-0.5 text-center md:text-3xl sm:text-2xl text-xl outline-none border-darkgrey focus:border-primary focus:shadow-primary"
              />
            </div>

            <Button
              isLoading={loading}
              className="w-full"
              onClick={() => {
                handleVerifyOTP(pin);
              }}
              value={t("Verify")}
            />
          </div>
        </div>
      ) : (
        <div className="flex flex-col md:gap-8 gap-4">
          <h3 className="text-4xl font-medium md:mb-6 mb-4 text-center">
            {t("Welcome!")}
          </h3>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <Input
                id="email"
                placeholder={t("Enter your email")}
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && formik.errors.email}
              />
            </div>
            <div className="mb-3">
              <div className="relative">
                <Input
                  placeholder={t("Enter your password")}
                  name="password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  id="password"
                  error={formik.touched.password && formik.errors.password}
                />
              </div>
              {/* {formik.touched.password && formik.errors.password && (
                <ul className="at-error list-disc list-inside text-red-700 mt-1 text-left text-sm">
                  <li>{t("Have at least 1 uppercase")}</li>
                  <li>{t("Have at least 1 special character")}</li>
                  <li>{t("Have at least 1 number")}</li>
                  <li>{t("Have at least 8 characters")}</li>
                </ul>
              )} */}
            </div>
            <div className="flex justify-end items-center">
              <p
                className="text-secondary-1000 cursor-pointer underline text-sm mb-8"
                onClick={() => {
                  setstate1(5);
                }}
              >
                {t("Forgot your password?")}
              </p>
            </div>
            <Button
              type="submit"
              isLoading={loading}
              disabled={!formik.isValid || !formik.dirty || loading}
              className="mb-10 w-full"
            >
              {t("Login")}
            </Button>
            <div className="flex items-center gap-4 justify-center my-8">
              <div className="w-full h-[1px] bg-secondary-10"></div>
              <p className="text-secondary-500 text-sm text-center flex-shrink-0">
                {t("or continue with")}
              </p>
              <div className="w-full h-[1px] bg-secondary-10"></div>
            </div>
            <div className="flex gap-5 justify-center mb-6">
              <GoogleLoginButton handleGoogleLogin={handleGoogleLogin} />
            </div>
            <p className="text-center text-secondary-1000 text-sm">
              {t("Don't have an account? ")} {" "}
              <span
                className="text-primary cursor-pointer"
                onClick={() => {
                  setstate1(2);
                }}
              >
                {t("Sign up")}
              </span>{" "}
            </p>
          </form>
        </div>
      )}
    </div>
  );
};

export default LoginModal;
